import { render, staticRenderFns } from "./referenzen-kunden-zitate-1.vue?vue&type=template&id=d600cae8&"
import script from "./referenzen-kunden-zitate-1.vue?vue&type=script&lang=js&"
export * from "./referenzen-kunden-zitate-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports